import styled from 'styled-components';

import { GetWorkPlan6BookingDTO } from '../../../../../api/api';
import Typography from '../../../../../components/typography/Typography';
import { formatDateHourString, getFullDateString } from '../../../../../utils/dateHandling';
import { getLocationString } from '../../../../../utils/location/locationHandling';

interface Props {
  booking: GetWorkPlan6BookingDTO;
}

const DayOverviewAbsenceBooking = ({ booking }: Props) => {
  // abscence reason is translated, but in the future this should happen in dynamics
  let absenceReason = translateAbsenceReason(booking.absenceReason);
  absenceReason = absenceReason ? "Fravær: " + absenceReason : 'Fravær';
  const address = getLocationString(booking.location);
  const hasAppointmentTime = booking.appointmentStart && booking.appointmentEnd;

  return (
    <BookingContainer>
      <AbsenceContainer>
        <TextContainer>
          {booking.plannedArrival && (
            <Typography variant="p" color="textMenu">
              {getFullDateString(new Date(booking.plannedArrival))} 
            </Typography>
          )}
          <Typography variant="b">{absenceReason}</Typography>
          {address && <Typography variant="p" color='textMenu'>{address}</Typography>}
        </TextContainer>
        <SelectedTime>
            <Typography variant="h4">
                {hasAppointmentTime
                ? `${formatDateHourString(booking.appointmentStart!)}\xa0- ${formatDateHourString(booking.appointmentEnd!)}`
                : ''}
                
            </Typography>
            <div><Typography variant="p" color="textMenu">Forventet ankomst: {booking.plannedArrival ? formatDateHourString(booking.plannedArrival) : 'N/A'}</Typography></div>
        </SelectedTime>
      </AbsenceContainer>
    </BookingContainer>
  );
};

const BookingContainer = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  margin: 12px;
`;

const SelectedTime = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-left: 12px;
`;

const AbsenceContainer = styled.div`
  background: ${(props) => props.theme.palette.functions.action.tertiary};
  margin-top: 0;
  padding: 16px 24px 16px 32px;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.15);
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  text-align: start;
`;

const absenceReasonTranslations: Record<string, string> = {
  'Sick': 'Syg',
  'Meeting': 'Møde',
  'Course': 'Kursus',
  'Doctors Appointment': 'Læge',
  'School': 'Skole',
  'Rest Shift': 'Hvilevagt',
  'Vacation': 'Ferie',
  'Requested Vacation': 'Ønsket ferie',
};

function translateAbsenceReason(reason: string | undefined): string | undefined {
  if (!reason) return undefined;
  return absenceReasonTranslations[reason] ?? reason;
}

export default DayOverviewAbsenceBooking;